<template>
  <div id="app" class="sys-app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  margin:0;
  padding:0;
}
#app {
  position: absolute;
  top:0;
  bottom:0;
  width:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue